import { render, staticRenderFns } from "./ESGInsightsByScope.vue?vue&type=template&id=4353ce04"
import script from "./ESGInsightsByScope.vue?vue&type=script&lang=js"
export * from "./ESGInsightsByScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports